import { render, staticRenderFns } from "./funct.vue?vue&type=template&id=12ab18a9&scoped=true&"
import script from "./funct.vue?vue&type=script&lang=js&"
export * from "./funct.vue?vue&type=script&lang=js&"
import style0 from "./funct.vue?vue&type=style&index=0&id=12ab18a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ab18a9",
  null
  
)

export default component.exports